import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BookingProvider } from "@/components/BookingContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import { routes } from "@/lib/site";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Treatments from "@/pages/Treatments";
import Symptoms from "@/pages/Symptoms";
import Testimonials from "@/pages/Testimonials";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <BookingProvider>
        <Layout>
          <Routes>
            <Route path={routes.home} element={<Home />} />
            <Route path={routes.about} element={<About />} />
            <Route path={routes.treatments} element={<Treatments />} />
            <Route path={routes.symptoms} element={<Symptoms />} />
            <Route path={routes.testimonials} element={<Testimonials />} />
            <Route path={routes.resources} element={<Resources />} />
            <Route path={routes.contact} element={<Contact />} />
            <Route path={routes.privacy} element={<PrivacyPolicy />} />
            <Route path={routes.terms} element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors />
      </BookingProvider>
    </BrowserRouter>
  );
}

export default App;
